import script from "./DevCommentsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DevCommentsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DevCommentsDrawer.vue?vue&type=style&index=0&id=bb3579c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb3579c8"]])

export default __exports__